import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { mediaUrl } from "../../lib/api";
import { useTryonJobs } from "../../lib/tryonJobs";

/* Ekranın aşağısındakı AI nəticə pəncərəsi. Generasiya gedərkən status,
   bitəndə nəticənin kiçik şəkli görünür; klik böyük baxışı açır.
   Geyinmə otağı açıq olanda (modal və ya /try-on səhifəsi) gizlənir —
   nəticə onsuz da qarşısındadır. */
export default function TryonResultDock() {
  const jobs = useTryonJobs();
  const location = useLocation();
  const [enlarged, setEnlarged] = useState(false);

  const job = jobs?.job;
  if (!job || jobs.uiOpen || location.pathname === "/try-on") return null;

  const dismiss = () => {
    setEnlarged(false);
    jobs.clear();
  };

  return (
    <>
      <div className="adf-tryon-dock" data-testid="tryon-dock" role="status">
        {job.status === "pending" && (
          <>
            <span className="adf-tryon-dock__spinner" aria-hidden="true" />
            <span className="adf-tryon-dock__text">
              AI nəticəniz hazırlanır{job.title ? ` — ${job.title}` : ""}…
            </span>
          </>
        )}
        {job.status === "done" && (
          <button
            type="button"
            className="adf-tryon-dock__result"
            onClick={() => setEnlarged(true)}
          >
            {job.resultUrl && (
              <img src={mediaUrl(job.resultUrl)} alt="AI nəticəsi" className="adf-tryon-dock__thumb" />
            )}
            <span className="adf-tryon-dock__text">Nəticəniz hazırdır — baxmaq üçün toxunun</span>
          </button>
        )}
        {job.status === "error" && (
          <span className="adf-tryon-dock__text">AI sınaq alınmadı — yenidən cəhd edin.</span>
        )}
        <button type="button" className="adf-tryon-dock__close" onClick={dismiss} aria-label="Bağla">
          <X size={14} aria-hidden="true" />
        </button>
      </div>

      {enlarged && job.status === "done" && job.resultUrl && (
        <div className="adf-tryon-dock-overlay" onClick={() => setEnlarged(false)} role="dialog" aria-label="AI nəticəsi">
          <img
            src={mediaUrl(job.resultUrl)}
            alt="AI nəticəsi"
            className="adf-tryon-dock-overlay__img"
            onClick={(event) => event.stopPropagation()}
          />
          <button
            type="button"
            className="adf-tryon-dock-overlay__close"
            onClick={() => setEnlarged(false)}
            aria-label="Bağla"
          >
            <X size={20} aria-hidden="true" />
          </button>
        </div>
      )}
    </>
  );
}
